<template>
    <div class="container-fluid mtb15 no-fluid">
        <div class="row sm-gutters">
            <!-- Menu -->
            <div v-if="1200 < getWindowsWidth" class="col-sm-12 col-md-2">
                <AppMenu></AppMenu>
            </div>
            <!-- Modal trade confirmed -->
            <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="tradeConfirmedLabel" aria-hidden="true"
                :class="{ 'show': tradeConfirmedModalShow, 'd-block': tradeConfirmedModalActive }">
                <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header trade-confirmed-modal-header">
                        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"
                            @click="tradeConfirmedModalActive = false; tradeConfirmedModalShow = false;"></button>
                    </div>
                    <div class="modal-body">
                        <TradeConfirmed :order="orderModel" />
                    </div>
                </div>
                </div>
            </div>               
            <!-- Modal add to watchlist -->
            <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="addToWatchlistLabel" aria-hidden="true"
                :class="{ 'show': watchlistSelectionModalShow, 'd-block': watchlistSelectionModalActive }">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="addToWatchlistLabel">{{
                            getWatchlistSelectionLabel }}</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="btn-group d-flex mtb15" role="group">
                                    <input type="radio" class="btn-check" :id="'newwl' + selectedItemCode" autocomplete="off"
                                        value="new" v-model="newWatchlistSelected">
                                    <label class="btn btn-outline-primary" :for="'newwl' + selectedItemCode">{{
                                        getNewWatchlistNameLabel
                                    }}</label>
                                    <input type="radio" class="btn-check" :id="'existwl' + selectedItemCode" value="old"
                                        v-model="newWatchlistSelected" autocomplete="off">
                                    <label class="btn btn-outline-primary" :for="'existwl' + selectedItemCode">{{
                                        getExistingWatchlistNameLabel
                                    }}</label>
                                </div>  
                            </div>
                            <div class="row" v-show="'new' === newWatchlistSelected">
                                <input :id="'watchlistName' + selectedItemCode" type="text" class="form-control"
                                    :placeholder="getWatchlistNamePlaceholder" v-model="watchlistName" />
                            </div>
                            <div class="row" v-show="'new' !== newWatchlistSelected">
                                <label :for="'watchlistName' + selectedItemCode">{{ getWatchlistSelectionLabel }}</label>
                                <select :id="'watchlistName' + selectedItemCode" class="form-select" v-model="watchlistName">
                                    <option v-for="(watchlist) in getWatchlists" :key="watchlist.wln"
                                        :value="watchlist.wln">{{ watchlist.wln }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal"
                                @click="updateWatchlist()" :disabled="'' === watchlistName">{{
                                getSaveLabel
                                }}</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                @click="watchlistSelectionModalActive = false; watchlistSelectionModalShow = false;">{{
                                getCloseLabel
                                }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="watchlistSelectionModalActive" class="modal-backdrop fade show">
            </div>
            <!-- Modal show trading in responsive -->
            <div v-if="1200 > getWindowsWidth" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="showTradingInResponsive" aria-hidden="true"
                :class="{ 'show': tradingInResponsiveModalShow, 'd-block': tradingInResponsiveModalActive }">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" 
                                @click="tradingInResponsiveModalShow = false; tradingInResponsiveModalActive = false; showTradingInResponsive = false;">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>                    
                        <div class="modal-body">
                            <Trading :key="this.selectedItemCode" :preserve-selected-instrument="true"></Trading>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Extended stock info -->
            <div class="col-sm-12" :class="{'col-md-10' : 1200 < getWindowsWidth }">
                <div class="settings mtb15">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-2">
                                <ul class="nav nav-tabs nav-pills" 
                                :class="{'settings-nav' : 1200 < getWindowsWidth, 'show_list_horizontal text-nowrap' : 1200 > getWindowsWidth}"
                                id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link"
                                            :class="{ 'active': 0 === activeExtendedStockItem.localeCompare('EXTENDED') }"
                                            id="Extended-tab" data-bs-toggle="tab"
                                            data-bs-target="#Extended" type="button" role="tab" aria-controls="Extended"
                                            :aria-selected="0 === activeExtendedStockItem.localeCompare('EXTENDED')"
                                            @click.prevent="inExtendedInfoMenuItemClick('Extended')">
                                            {{ getInformationLabel.toUpperCase() }}
                                        </button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" 
                                            :class="{ 'active': 0 === activeExtendedStockItem.localeCompare('GRAPH') }"
                                            id="Graph-tab" data-bs-toggle="tab"
                                            data-bs-target="#Graph" type="button" role="tab" aria-controls="Graph"
                                            :aria-selected="0 === activeExtendedStockItem.localeCompare('GRAPH')"
                                            @click.prevent="inExtendedInfoMenuItemClick('Graph')">
                                            {{ getGraphLabel.toUpperCase() }}
                                        </button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" 
                                            :class="{ 'active': 0 === activeExtendedStockItem.localeCompare('DEPTH') }"
                                            id="Depth-tab" data-bs-toggle="tab"
                                            data-bs-target="#Depth" type="button" role="tab" aria-controls="Depth"
                                            :aria-selected="0 === activeExtendedStockItem.localeCompare('DEPTH')"
                                            @click.prevent="inExtendedInfoMenuItemClick('Depth')">
                                            {{ getDepthLabel.toUpperCase() }}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-6">
                                <div class="tab-content" id="myTabContent">
                                    <div class="tab-pane fade"
                                        :class="{ 'show active': 0 === activeExtendedStockItem.localeCompare('EXTENDED') }"
                                        id="Extended" role="tabpanel"
                                        aria-labelledby="Extended-tab">
                                        <div v-if="isStockInfoReady" class="card border-dark">
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-flex">
                                                        <div class="instrument-header">
                                                            <strong class="instrument-code-main">{{ selectedItemCode }}</strong>
                                                            <strong class="instrument-name-main">{{ getStockName }}</strong>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <p class="text-end">
                                                            <button v-if="!isStockPartOfDefaultWatchlist" class="btn btn-primary" @click="updateWatchlist">+</button>
                                                            <button v-else class="btn btn-primary" @click="removeFromWatchlist">-</button>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="instrument-price-row">
                                                    <div>
                                                        <strong class="instrument-price-main">
                                                            {{ formatPrice(getQuoteEx().ldp, getStockCurrency).replace(' ', '&nbsp;') }}
                                                        </strong>
                                                        <span v-if="0 < parseFloat(getQuoteEx().ch)" class="green instrument-change-main">+{{ parseNumber(getQuoteEx().ch, 4) }}% (+{{ parseNumber(getQuoteEx().dif, 4) }})</span>
                                                        <span v-else class="red instrument-change-main instrument-change-negative">{{ parseNumber(getQuoteEx().ch) }}% ({{ parseNumber(getQuoteEx().dif) }})</span>
                                                    </div>
                                                    <div v-if="!isClosedMarked" class="market-phase-cell">{{ getExchangePhaseLabel }}
                                                        <label class="label greenColor">
                                                            <strong>{{ getMarketPhaseLabel }}</strong>
                                                        </label>
                                                    </div>
                                                    <div v-else class="market-phase-cell">{{ getExchangePhaseLabel }} 
                                                        <label class="label redColor">
                                                            <strong>{{ getMarketPhaseLabel }}</strong>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="table-responsive">
                                                    <table class="table instrument-details-table">
                                                        <tbody>
                                                            <tr>
                                                                <td><strong>{{ getPreviousCloseLabel }}</strong></td>
                                                                <td class="align-text-right">{{ formatPrice(getQuoteEx().prc, getStockCurrency).replace(' ', '&nbsp;') }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>{{ getDailyVolumeLabel }}</strong></td>
                                                                <td class="align-text-right">{{ parseNumber(getQuoteEx().dv, 0) }}</td>
                                                            </tr>
                                                            <tr style="color: #0F7392;">
                                                                <td><strong>{{ getQuantityLabel }}</strong></td>
                                                                <td class="align-text-right">{{ parseNumber(getQuoteEx().bq, 0) }}</td>
                                                            </tr>
                                                            <tr style="color: #0F7392;">
                                                                <td><strong>{{ getBidLabel }}</strong></td>
                                                                <td class="align-text-right">{{ formatPrice(getQuoteEx().b, getStockCurrency).replace(' ', '&nbsp;') }}</td>
                                                            </tr>
                                                            <tr style="color: #EC6024;">
                                                                <td><strong>{{ getAskLabel }}</strong></td>
                                                                <td class="align-text-right">{{ formatPrice(getQuoteEx().a, getStockCurrency).replace(' ', '&nbsp;') }}</td>
                                                            </tr>
                                                            <tr style="color: #EC6024;">
                                                                <td><strong>{{ getQuantityLabel }}</strong></td>
                                                                <td class="align-text-right">{{ parseNumber(getQuoteEx().sq, 0) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>{{ getTickSizeLabel }}</strong></td>
                                                                <td class="align-text-right">{{ parseNumber(calculateTickSize, 10).replace(/\.?0+$/, "") }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>{{ getExchangeNameLabel }}</strong></td>
                                                                <td class="align-text-right">{{ getExchange?.code?.toUpperCase() }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>{{ getSegmentLabel }}</strong></td>
                                                                <td class="align-text-right">{{ selectedItemSegment?.toUpperCase() }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><strong>{{ getInstrumentTypeLabel }}</strong></td>
                                                                <td class="align-text-right">{{ getStockTypeLabel }}</td>
                                                            </tr>
                                                            <tr class="instrument-isin-row">
                                                                <td><strong>ISIN</strong></td>
                                                                <td class="align-text-right">{{ getStockIsin }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" 
                                        :class="{ 'show active': 0 === activeExtendedStockItem.localeCompare('DEPTH') }"
                                        id="Depth" role="tabpanel" aria-labelledby="Depth-tab">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-flex">
                                                        <div class="instrument-header">
                                                            <strong class="instrument-code-main">{{ selectedItemCode }}</strong>
                                                            <strong class="instrument-name-main">{{ getStockName }}</strong>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <p class="text-end">
                                                            <button v-if="!isStockPartOfDefaultWatchlist" class="btn btn-primary" @click="updateWatchlist">+</button>
                                                            <button v-else class="btn btn-primary" @click="removeFromWatchlist">-</button>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="instrument-price-row">
                                                    <div>
                                                        <strong class="instrument-price-main">
                                                            {{ formatPrice(getQuoteEx().ldp, getStockCurrency).replace(' ', '&nbsp;') }}
                                                        </strong>
                                                        <span v-if="0 < parseFloat(getQuoteEx().ch)" class="green instrument-change-main">+{{ parseNumber(getQuoteEx().ch, 4) }}% (+{{ parseNumber(getQuoteEx().dif, 4) }})</span>
                                                        <span v-else class="red instrument-change-main instrument-change-negative">{{ parseNumber(getQuoteEx().ch) }}% ({{ parseNumber(getQuoteEx().dif) }})</span>
                                                    </div>
                                                    <div v-if="!isClosedMarked" class="market-phase-cell">{{ getExchangePhaseLabel }}
                                                        <label class="label greenColor">
                                                            <strong>{{ getMarketPhaseLabel }}</strong>
                                                        </label>
                                                    </div>
                                                    <div v-else class="market-phase-cell">{{ getExchangePhaseLabel }} 
                                                        <label class="label redColor">
                                                            <strong>{{ getMarketPhaseLabel }}</strong>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="table-responsive">
                                                    <table class="table instrument-details-table">
                                                        <tbody>
                                                            <tr>
                                                                <td>{{ getLastTransactionLabel }}</td>
                                                                <td class="align-text-right">
                                                                    <strong>{{ parseNumber(getDepth().ldc, 0) }} x {{ formatPrice(getDepth().ldp, getStockCurrency).replace(' ', '&nbsp;') }}</strong>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>{{ getDailyVolumeLabel }}</td>
                                                                <td class="align-text-right"><strong>{{ parseNumber(getDepth().dv, 0) }}</strong></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="row">
                                                    <div class="btn-group d-flex mtb15" role="group">
                                                        <input type="radio" class="btn-check" id="otbid" autocomplete="off" value="B" v-model="depthDetails">
                                                        <label class="btn btn-outline-primary" for="otbid">{{ getBidLabel }}</label>
                                                        <input type="radio" class="btn-check" id="otask" value="S" v-model="depthDetails" autocomplete="off">
                                                        <label class="btn btn-outline-primary" for="otask">{{ getAskLabel }}</label>
                                                    </div>                                                    
                                                </div>
                                                <div class="table-responsive">
                                                    <table class="table depth-order-book-table" style='table-layout:fixed;'>
                                                        <thead>
                                                            <tr>
                                                                <template v-if="'B' === depthDetails">
                                                                    <th class="align-text-center">{{ getBidLabel }}</th>
                                                                    <th class="align-text-center">{{ getQuantityLabel }}</th>
                                                                    <th class="align-text-center">&Sigma;{{ getQuantityLabel }}</th>
                                                                    <th class="align-text-center">{{ getOrdersLabel }}</th>
                                                                </template>
                                                                <template v-else>
                                                                    <th class="align-text-center">{{ getOrdersLabel }}</th>
                                                                    <th class="align-text-center">&Sigma;{{ getQuantityLabel }}</th>
                                                                    <th class="align-text-center">{{ getQuantityLabel }}</th>
                                                                    <th class="align-text-center">{{ getAskLabel }}</th>
                                                                </template>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-if="'B' === depthDetails">
                                                            <tr v-for="(item, index) in getDepth().B" :key="index" @click="setTradingActionquantityAndPrice('S', item.q, item.p)">
                                                                <td class="align-text-center">{{ formatPrice(item.p, getStockCurrency).replace(' ', '&nbsp;') }}</td>
                                                                <td class="align-text-center">{{ parseNumber(item.q, 0) }}</td>
                                                                <td class="align-text-center">{{ parseNumber(sigmaB[index], 0) }}</td>
                                                                <td v-if="item.oc" class="align-text-center">{{ parseNumber(item.oc, 0) }}</td>
                                                                <td v-else class="align-text-center">&nbsp;</td>
                                                            </tr>
                                                        </tbody>
                                                        <tbody v-else>
                                                            <tr v-for="(item, index) in getDepth().A" :key="index" @click="setTradingActionquantityAndPrice('B', item.q, item.p)">
                                                                <td v-if="item.oc" class="align-text-center">{{ parseNumber(item.oc, 0) }}</td>
                                                                <td v-else class="align-text-center">&nbsp;</td>
                                                                <td class="align-text-center">{{ parseNumber(sigmaA[index], 0) }}</td>
                                                                <td class="align-text-center">{{ parseNumber(item.q, 0) }}</td>
                                                                <td class="align-text-center">{{ formatPrice(item.p, getStockCurrency).replace(' ', '&nbsp;') }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" 
                                        :class="{ 'show active': 0 === activeExtendedStockItem.localeCompare('GRAPH') }"
                                        id="Graph" role="tabpanel" aria-labelledby="Graph-tab">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-flex">
                                                        <div class="instrument-header">
                                                            <strong class="instrument-code-main">{{ selectedItemCode }}</strong>
                                                            <strong class="instrument-name-main">{{ getStockName }}</strong>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <p class="text-end">
                                                            <button v-if="!isStockPartOfDefaultWatchlist" class="btn btn-primary" @click="updateWatchlist">+</button>
                                                            <button v-else class="btn btn-primary" @click="removeFromWatchlist">-</button>                                                            
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="instrument-price-row">
                                                    <div>
                                                        <strong class="instrument-price-main">
                                                            {{ formatPrice(getQuoteEx().ldp, getStockCurrency).replace(' ', '&nbsp;') }}
                                                        </strong>
                                                        <span v-if="0 < parseFloat(getQuoteEx().ch)" class="green instrument-change-main">+{{ parseNumber(getQuoteEx().ch, 4) }}% (+{{ parseNumber(getQuoteEx().dif, 4) }})</span>
                                                        <span v-else class="red instrument-change-main instrument-change-negative">{{ parseNumber(getQuoteEx().ch) }}% ({{ parseNumber(getQuoteEx().dif) }})</span>
                                                    </div>
                                                    <div v-if="!isClosedMarked" class="market-phase-cell">{{ getExchangePhaseLabel }}
                                                        <label class="label greenColor">
                                                            <strong>{{ getMarketPhaseLabel }}</strong>
                                                        </label>
                                                    </div>
                                                    <div v-else class="market-phase-cell">{{ getExchangePhaseLabel }} 
                                                        <label class="label redColor">
                                                            <strong>{{ getMarketPhaseLabel }}</strong>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div id="history_depth_menu" class="chart-range-menu">
                                                    <input type="radio" class="btn-check" id="day" autocomplete="off"
                                                        value="day" v-model="graphInterval" :disabled="disabled">
                                                    <label class="btn btn-outline-primary" for="day">1D</label>
                                                    <input type="radio" class="btn-check" id="week" value="week"
                                                        v-model="graphInterval" autocomplete="off" :disabled="disabled">
                                                    <label class="btn btn-outline-primary" for="week">1W</label>
                                                    <input type="radio" class="btn-check" id="month" value="month"
                                                        v-model="graphInterval" autocomplete="off" :disabled="disabled">
                                                    <label class="btn btn-outline-primary" for="month">1M</label>
                                                    <input type="radio" class="btn-check" id="sixmonths" value="6mo"
                                                        v-model="graphInterval" autocomplete="off" :disabled="disabled">
                                                    <label class="btn btn-outline-primary" for="sixmonths">6M</label>
                                                    <input type="radio" class="btn-check" id="ytd" value="ytd"
                                                        v-model="graphInterval" autocomplete="off" :disabled="disabled">
                                                    <label class="btn btn-outline-primary" for="ytd">YTD</label>
                                                    <input type="radio" class="btn-check" id="year" value="1year"
                                                        v-model="graphInterval" autocomplete="off" :disabled="disabled">
                                                    <label class="btn btn-outline-primary" for="year">1Y</label>
                                                    <input type="radio" class="btn-check" id="years3" value="3years"
                                                        v-model="graphInterval" autocomplete="off" :disabled="disabled">
                                                    <label class="btn btn-outline-primary" for="years3">3Y</label>
                                                    <input type="radio" class="btn-check" id="years5" value="5years"
                                                        v-model="graphInterval" autocomplete="off" :disabled="disabled">
                                                    <label class="btn btn-outline-primary" for="years5">5Y</label>
                                                    <input type="radio" class="btn-check" id="max" value="max"
                                                        v-model="graphInterval" autocomplete="off" :disabled="disabled">
                                                    <label class="btn btn-outline-primary" for="max">MAX</label>
                                                </div>                                               
                                                <div v-if="chartDataLoading || !chartDataLoaded" class="chart-loading-state">
                                                    <Preloader />
                                                </div>
                                                <div v-else-if="hasChartData" class="d-flex align-items-center justify-content-center">
                                                    <AreaChart :height="1200 < getWindowsWidth ? 480 : 240" :width="1200 < getWindowsWidth ? 640 : 320" :data="chartSeriesData" :labels="seriesLabels"></AreaChart>
                                                </div>
                                                <div v-else class="chart-empty-state">
                                                    <h4>{{ getChartDataForInstrumentUnavailableMessage }}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="1200 < getWindowsWidth" class="col-lg-4">
                                <Trading :key="this.selectedItemCode" :preserve-selected-instrument="true"></Trading>
                            </div>                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- trade button -->
        <button v-if="1200 > getWindowsWidth && !showTradingInResponsive" id="tradeButton" class="btn position-fixed bottom-0 end-0" 
            @click.prevent="showTradingInResponsive = true; tradingInResponsiveModalShow = true; tradingInResponsiveModalActive = true;">
            <img src="@/assets/images/trade_button.svg" alt="">
        </button>        
    </div>
</template>

<script>
import AppMenu from "@/components/ui/AppMenu.vue";
import AreaChart from "@/components/charts/AreaChart.vue";
import Preloader from "@/components/ui/Preloader.vue";
import http from "@/api/http-common";
import UiUtils from "@/assets/js/ui_utils.js";
import ApiUtils from "@/assets/js/api_utils.js";
import I18n from "@/lang/i18n.js";
import Trading from '@/features/trading/TradingView.vue';
import TradeConfirmed from '@/features/trading/components/TradeConfirmed.vue';
import HttpUtils from "@/assets/js/http_utils.js";
import { getStockTypeLabel } from "@/features/stocks/stock-type-labels";
import { addSseEventListeners, closeSseClient, createSseClient, parseSseJsonEvent, startSseMonitor, stopSseMonitor } from "@/api/sse-client";

// exchange liquidity price levels
const sdLiqPriceLevels = [0, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000];
// exchange tick sizes for limit prices
const sdMaxTickSizes = [500, 500, 200, 100, 50, 20, 10, 5, 2, 1, 0.5];
const STRING_NOT_AVAILABLE = "n/a";

export default {
    components: {
        AppMenu,
        AreaChart,
        Preloader,
        Trading,
        TradeConfirmed
    },
    data() {
        return {
            changePercent: null,
            changeColor: "blackColor",
            buy: null,
            buyColor: "blackColor",
            depthDetails: 'B',
            graphInterval: "ytd",
            seriesData: [],
            seriesLabels: [],
            chartDataLoading: false,
            chartDataLoaded: false,
            sigmaB: [],
            sigmaA: [],
            /* active modal dialog for watchlist selection */
            watchlistSelectionModalActive: false,
            /* show modal dialog for watchlist selection */
            watchlistSelectionModalShow: false,   
            newWatchlistSelected: "old",
            watchlistName: "Default",
            disabled: false,
            timeout: null,
            selectedItemCode: this.stockCode || this.$store.getters["getSelectedTradingCode"],
            selectedItemExchangeId: parseInt(this.itemExchangeId) || this.$store.getters["getSelectedTradingExchangeId"],
            selectedItemSegment: this.itemStockCodeSegment || this.$store.getters["getSelectedTradingCodeSegment"],
            activeExtendedStockItem: "EXTENDED",
            tradeConfirmedModalActive: false,
            tradeConfirmedModalShow: false,
            orderModel: {},
            hasReestablishingConnectionMessage: false,
            sseVerifier: null,
            hasEvents: false,
            sseClient: null,
            showTradingInResponsive: false,
            tradingInResponsiveModalShow: false,
            tradingInResponsiveModalActive: false,
            xfraIsinRequests: {}
        }
    },
    props: {
        stockCode: {
            required: true,
            type: String
        },
        itemExchangeId: {
            required: true,
            type: String
        }
    },
    watch: {
        changePercent: function(newVal, oldVal) {
            if (null != oldVal && null != oldVal && newVal !== oldVal) {
                if (oldVal > newVal) {
                    this.changeColor = "red";
                } else if (oldVal < newVal) {
                    this.changeColor = "green";
                }
            }
        },
        buy: function (newVal, oldVal) {
            if (null != oldVal && null != oldVal && newVal !== oldVal) {
                if (oldVal > newVal) {
                    this.buyColor = "red";
                } else if (oldVal < newVal) {
                    this.buyColor = "green";
                }
                // restore
                setTimeout(() => {
                    this.buyColor = "blackColor";
                }, 2000);
            }
        },
        graphInterval: function (newVal, oldVal) {
            if (oldVal !== newVal) {
                this.disabled = true;

                // Re-enable after 0.5 seconds
                this.timeout = setTimeout(() => {
                    this.disabled = false
                }, 500);
                (async () => {
                    // gathering data could be a long process, so we set the wait
                    this.$store.commit("setAppStateNotReady");
                    await this.getInstrumentHistory();
                    this.$store.commit("setAppStateReady");
                })();
            }
        },
        getSelectedTradingCode: function (newVal, oldVal) {
            if (oldVal !== newVal) {
                this.selectedItemCode = newVal;
                this.selectedItemExchangeId = this.$store.getters["getSelectedTradingExchangeId"];
                this.selectedItemSegment = this.$store.getters["getSelectedTradingCodeSegment"];
                setTimeout(() => {
                    (async () => {
                        await Promise.all([this.getQuoteTr(), this.setQuoteExAndDepth(), this.getQuoteExAndDepth(), this.getInstrumentHistory()]);
                        await this.ensureXfraIsin();
                    })();
                    this.getQuoteEx();
                }, 300);
            }
        },
        stopSseState: function (newVal) {
            if (newVal) {
                if (this.sseClient) {
                    closeSseClient(this.sseClient);
                    this.$store.commit("setStopSse", false);
                }
            }
        }
    },
    methods: {
        t(key, ...args) {
            const language = typeof this.getUserLanguage === "function" ? this.getUserLanguage() : this.getUserLanguage;
            return I18n.t(key, language, ...args);
        },
        getUserType() {
            return this.$store.getters["getUserType"];
        },
        getOrderType(ot) {
            return 'b' === ot || 'B' === ot ?
                this.t("buyLabel") :
                this.t("sellLabel");
        },
        getDate(unix) {
            return UiUtils.parseUnixTime(unix);
        },
        getBuyLabel() {
            return this.t("buyLabel");
        },
        getSellLabel() {
            return this.t("sellLabel");
        },
        getStockNameByCode(stockCode) {
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return UiUtils.getStockName(stocks, indexedStocks, stockCode, this.getUserLanguage());
        },
        setupStream() {
            const user = this.$store.getters["getUser"];
            if (!user) {
                return;
            }
            try {
                this.sseClient = createSseClient(this.getUserType(), user);

                // verify we have valid connection
                if (!this.sseClient) {
                    return;
                }
                // show message if connection has been lost
                if (this.hasReestablishingConnectionMessage) {
                    const reestablishConnectionMessage = this.getReestablishedConnectionLabel;
                    // show user info
                    this.$toast.success(reestablishConnectionMessage, {
                        "duration": 5000,
                        "pauseOnHover": true
                    });
                    this.$store.commit("addSystemMessage", {
                        date: (new Date()).getTime(),
                        mess: reestablishConnectionMessage,
                        error: false
                    });
                    this.hasReestablishingConnectionMessage = false;
                }

                addSseEventListeners(this.sseClient, this.extendedStockSseHandlers());
            } catch (error) {
                console.error(error);
            }
        },
        extendedStockSseHandlers() {
            return {
                HEARTBEAT: () => {
                    this.hasEvents = true;
                },
                SESSION_CLOSED: () => {
                    this.hasEvents = true;
                    ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1);
                },
                QUOTE: event => this.commitSseJson("updateQuote", event, false),
                QUOTE_TR: event => this.commitSseJson("setQuoteTrading", event),
                QUOTE_EX: event => this.commitSseJson("setQuoteExtended", event),
                DEPTH: event => this.handleExtendedStockDepthSseEvent(event),
                PHASE: event => this.commitSseJson("upsertExchangesPhases", event),
                EXECUTED: event => this.handleExtendedStockExecutedSseEvent(event),
                REJECTED: event => this.handleExtendedStockRejectedSseEvent(event),
                error: event => this.handleExtendedStockSseError(event)
            };
        },
        commitSseJson(mutation, event, markEvents = true) {
            if (markEvents) {
                this.hasEvents = true;
            }
            try {
                this.$store.commit(mutation, parseSseJsonEvent(event));
            } catch (err) {
                console.error(err);
            }
        },
        handleExtendedStockDepthSseEvent(event) {
            this.hasEvents = true;
            try {
                const obj = parseSseJsonEvent(event);
                this.$store.commit("setDepth", obj);
                // calculate sigmas
                let sigma = 0;
                this.sigmaA = [];
                this.sigmaB = [];
                for (let cnt = 0; cnt < obj.B.length; cnt++) {
                    if (0 === cnt) {
                        sigma = obj.B[cnt].q;
                    } else {
                        sigma = sigma + obj.B[cnt].q;
                    }
                    this.sigmaB.push(sigma);
                }
                sigma = 0;
                for (let cnt = 0; cnt < obj.A.length; cnt++) {
                    if (0 === cnt) {
                        sigma = obj.A[cnt].q;
                    } else {
                        sigma = sigma + obj.A[cnt].q;
                    }
                    this.sigmaA.push(sigma);
                }
            } catch (err) {
                console.error(err);
            }
        },
        handleExtendedStockExecutedSseEvent(event) {
            this.hasEvents = true;
            try {
                const orderData = parseSseJsonEvent(event);
                this.formOrderObject(orderData);
                this.tradeConfirmedModalShow = true;
                this.tradeConfirmedModalActive = true;
                let mess = "";
                if (0 === "BG".localeCompare(this.getUserLanguage())) {
                    mess = "Вашата поръчка №";
                } else {
                    mess = "Your order #";
                }
                mess = mess + orderData.id + ", " + this.getDate(orderData.d) +
                    ", " + this.getOrderType(orderData.t) + " " + orderData.sc + "(" + this.getStockNameByCode(orderData.sc) + ") " +
                    orderData.qty + "@" + orderData.sp + " " + orderData.cc;
                if (0 === "BG".localeCompare(this.getUserLanguage())) {
                    mess = mess + " е изпълнена";
                } else {
                    mess = mess + " is completed";
                }
                this.$toast.success(mess, {
                    "duration": 5000,
                    "pauseOnHover": true
                });
                this.$store.commit("addSystemMessage", {
                    date: (new Date()).getTime(),
                    mess: mess,
                    error: false
                });
            } catch (err) {
                console.error(err);
            }
        },
        handleExtendedStockRejectedSseEvent(event) {
            this.hasEvents = true;
            try {
                const orderData = parseSseJsonEvent(event);
                let mess = "";
                if (0 === "BG".localeCompare(this.getUserLanguage())) {
                    mess = "Вашата поръчка №";
                } else {
                    mess = "Your order #";
                }
                const stockName = orderData.nBG
                    ? orderData.nBG : orderData.nEN;
                mess = mess + orderData.oid + ", " + this.getDate(orderData.ts) +
                    ", " + orderData.sc + "(" + stockName + ") " +
                    orderData.qty + "@" + orderData.sp + " " + orderData.cc;
                if (0 === "BG".localeCompare(this.getUserLanguage())) {
                    mess = mess + " е отказана";
                } else {
                    mess = mess + " is rejected";
                }
                this.$toast.error(mess, {
                    "duration": 5000,
                    "pauseOnHover": true
                });
                this.$store.commit("addSystemMessage", {
                    date: (new Date()).getTime(),
                    mess: mess,
                    error: true
                });
            } catch (err) {
                console.error(err);
            }
        },
        handleExtendedStockSseError(event) {
            this.hasEvents = false;
            try {
                if (event.readyState == EventSource.CLOSED) {
                    console.log(EventSource);
                }
            } catch (err) {
                console.error(err);
            }
        },
        getUserLanguage() {
            return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
        },
        getStartDateForInstrumentHistory() {
            const nowDate = new Date();
            let prevDate = new Date(nowDate.getTime());
            
            switch (this.graphInterval) {
                case "day": {
                    if (0 === nowDate.getDay()) {
                        prevDate.setDate(nowDate.getDate() - 3);
                    } else if (6 === nowDate.getDay()) {
                        prevDate.setDate(nowDate.getDate() - 2);

                    } else {
                        prevDate.setDate(nowDate.getDate() - 1);
                    }
                    break;
                }
                case "week": {
                    prevDate.setDate(nowDate.getDate() - 7);
                    break;
                }
                case "month": {
                    prevDate.setDate(nowDate.getDate() - 30);
                    break;
                }
                case "6mo": {
                    prevDate.setDate(nowDate.getDate() - 180);
                    break;
                }
                case "1year": {
                    prevDate.setDate(nowDate.getDate() - 360);
                    break;
                }
                case "ytd": {
                    prevDate = new Date(nowDate.getFullYear(), 0, 1);
                    break;
                }
                case "3years": {
                    prevDate.setDate(nowDate.getDate() - 1080);
                    break;
                }
                case "5years": {
                    prevDate.setDate(nowDate.getDate() - 1800);
                    break;
                }
                case "max": {
                    prevDate.setDate(nowDate.getDate() - 3600);
                    break;
                }
            }            
            return parseInt(prevDate.getTime() / 1000);            
        },
        getIntervalForInstrumentHistory() {
            switch (this.graphInterval) {
                case "day": {
                    // day
                    return "5m";
                }
                case "week": {
                    // week
                    return "30m";
                }
                case "month": 
                case "6mo":
                case "1year":
                case "ytd": {
                    // month, 6 months, year, year to date
                    return "1d";
                }
                case "3years":
                case "5years": {
                    return "1w";
                }
                case "max": {
                    return "1mo"
                }                
            }
            return "5m";
        },
        async getInstrumentHistory() {
            if (!this.selectedItemCode) {
                return;
            }
            const user = this.$store.getters["getUser"];
            this.chartDataLoading = true;
            this.chartDataLoaded = false;
            this.seriesData.length = 0;
            this.seriesLabels = [];
            try {
                const res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: "get_instrument_history_ex",
                        id: user.id,
                        key: user.key,
                        sc: this.selectedItemCode,
                        sd: this.getStartDateForInstrumentHistory(),
                        ed: parseInt((new Date()) / 1000),
                        it: this.getIntervalForInstrumentHistory(),
                        ex: this.getExchange?.code
                    }
                });
                if (res) {
                    // check answer
                    if (ApiUtils.isApiResponseInvalidSession(res)) {
                        this.$store.commit("setAppStateReady");
                        // logout
                        setTimeout(
                            ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
                            500);
                        return;
                    }
                    // get the error message if appropriate
                    const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage());
                    if (errorCode === "") {
                        const historyData = [];
                        const historyLabels = [];
                        (res.data.list || []).forEach(item => {
                            (item.data || []).forEach(data => {
                                historyLabels.push(data.tS.slice(0, 16));
                                historyData.push([data.t * 1000, data.hi]);
                            });
                        });
                        this.seriesLabels = historyLabels;
                        this.seriesData.length = 0;
                        if (0 < historyData.length) {
                            this.seriesData.push({
                                data: historyData
                            });
                        }
                    } else {
                        this.seriesData.length = 0;
                        this.$toast.error(errorCode, {
                            "duration": 5000,
                            "pauseOnHover": true
                        });
                        this.$store.commit("addSystemMessage", {
                            date: (new Date()).getTime(),
                            mess: errorCode,
                            error: true
                        });
                    }
                }
            } catch (err) {
                console.error(err);
            } finally {
                this.chartDataLoading = false;
                this.chartDataLoaded = true;
            }
        },        
        async setQuoteExAndDepth() {
            if ("" === this.selectedItemCode) {
                return;
            }
            // set sse for quote tr
            const user = this.$store.getters["getUser"];
            const exchange = this.getExchange;
            try {                
                const res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: "set_sse",
                        id: user.id,
                        key: user.key,
                        "phase-sts": "on",
                        "quote-sts": "off",
                        "quote-ex-set": !this.selectedItemCode ? null : UiUtils.combineExchangeStockPair(exchange.code, this.selectedItemCode),
                        "quote-ex-sts": !this.selectedItemCode ? "off" : "on",
                        "quote-tr-set": !this.selectedItemCode ? null : UiUtils.combineExchangeStockPair(exchange.code, this.selectedItemCode),
                        "quote-tr-sts": !this.selectedItemCode ? "off" : "on",
                        "depth-set": !this.selectedItemCode ? null : UiUtils.combineExchangeStockPair(exchange.code, this.selectedItemCode),
                        "depth-sts": !this.selectedItemCode ? "off" : "on"
                    }
                });
                if (res) {
                    // check answer
                    if (0 !== res.data.ec) {
                        this.$toast.error(this.getCouldNotSetQuoteMessage, {
                            "duration": 5000,
                            "pauseOnHover": true
                        });
                        this.$store.commit("addSystemMessage", {
                            date: (new Date()).getTime(),
                            mess: this.getCouldNotSetQuoteMessage,
                            error: true
                        });
                    }
                }
            } catch (err) {
                console.error(err);
            }
        },
        async getQuoteExAndDepth() {
            if ("" === this.selectedItemCode) {
                return;
            }
            // get quote ex
            const user = this.$store.getters["getUser"];
            const exchange = this.getExchange;
            try {
                let res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: "get_quote_ex",
                        id: user.id,
                        key: user.key,
                        sc: UiUtils.combineExchangeStockPair(exchange.code, this.selectedItemCode)
                    }
                });
                if (res) {
                    // check answer
                    if (ApiUtils.isApiResponseInvalidSession(res)) {
                        this.$store.commit("setAppStateReady");
                        // logout
                        setTimeout(
                            ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
                            500);
                        return;
                    }
                    // get the error message if appropriate
                    const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage());
                    if (errorCode === "") {
                        // set in vuex
                        this.$store.commit("setQuoteExtended", res.data);
                    } else {
                        this.$toast.error(errorCode, {
                            "duration": 5000,
                            "pauseOnHover": true
                        });
                        this.$store.commit("addSystemMessage", {
                            date: (new Date()).getTime(),
                            mess: errorCode,
                            error: true
                        });
                    }
                } 
                // get depth
                res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: "get_depth",
                        id: user.id,
                        key: user.key,
                        sc: UiUtils.combineExchangeStockPair(exchange.code, this.selectedItemCode)
                    }
                });
                if (res) {
                    // check answer
                    if (ApiUtils.isApiResponseInvalidSession(res)) {
                        this.$store.commit("setAppStateReady");
                        // logout
                        setTimeout(
                            ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
                            500);
                        return;
                    }
                    // get the error message if appropriate
                    const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage());
                    if (errorCode === "") {
                        // set in vuex
                        this.$store.commit("setDepth", res.data);
                        // calculate sigmas if any
                        let sigma = 0;
                        if (res?.data?.B && 0 < res?.data?.B?.length) {
                            for (let cnt = 0; cnt < res.data.B.length; cnt++) {
                                if (0 === cnt) {
                                    sigma = res.data.B[cnt].q;
                                } else {
                                    sigma = sigma + res.data.B[cnt].q;
                                }
                                this.sigmaB.push(sigma);
                            } 
                        }
                        sigma = 0;
                        if (res?.data?.A && 0 < res?.data?.A?.length) {
                            for (let cnt = 0; cnt < res.data.A.length; cnt++) {
                                if (0 === cnt) {
                                    sigma = res.data.A[cnt].q;
                                } else {
                                    sigma = sigma + res.data.A[cnt].q;
                                }
                                this.sigmaA.push(sigma);
                            }
                        }
                    } else {
                        this.$toast.error(errorCode, {
                            "duration": 5000,
                            "pauseOnHover": true
                        });
                        this.$store.commit("addSystemMessage", {
                            date: (new Date()).getTime(),
                            mess: errorCode,
                            error: true
                        });
                    }
                }
            } catch (err) {
                console.error(err);
            }
        },
        getQuoteEx() {
            const quoteEx = this.$store.getters["getQuoteExtended"];
            this.changePercent = quoteEx && quoteEx.ch ? quoteEx.ch : "n/a";
            this.buy = quoteEx && quoteEx.b ? quoteEx.b : "n/a";
            return quoteEx && quoteEx.prc 
                ? quoteEx 
                : { b: 0, a: 0, dif: 0, ch: 0, bq: 0, sq: 0, ldc: 0, ldp: 0, "1yr": 0, mc: 0, pe: 0, prc: 0, dv: 0 };
        },
        getDepth() {
            const depth = this.$store.getters["getDepth"];
            this.changePercent = depth && depth.ch ? depth.ch : "n/a";
            this.buy = depth && depth.ldp ? depth.ldp : "n/a";
            return depth && depth.ldp ?
                depth :
                { bcp: 0, acp: 0, dif: 0, ch: 0, ldc: 0, ldp: 0, dv: 0, B: [], A: [] };
        },
        openTrader() {
            const stocks = this.$store.getters["getStocks"];
            const mapped  = stocks.filter(item => {
                return 0 === item.code.toString().toUpperCase().localeCompare(this.selectedItemCode.toUpperCase() &&
                    parseInt(item.cMIC) === this.selectedItemExchangeId);
            });
            this.$store.commit("setSearchedStocksUserWatchlist", mapped);
            this.$store.commit("setSearchedStocksIndexWatchlist", mapped);
            // this is ither market or limit order
            this.$store.commit("setOrderIdToUpdate", "");
//            this.inExtendedInfoMenuItemClick('trade');
//            this.$router.push({ name: "Trader" });
        },
        setTradingActionquantityAndPrice(action, qty, price) {
            this.$store.commit("setSelectedTradingAction", action);
            this.$store.commit("setSelectedTradingQuantity", qty);
            this.$store.commit("setSelectedTradingPrice", price); 

            this.openTrader();
        },
        parseNumber(num, afterDot = 2) {
            return UiUtils.formatNumber(num, afterDot);
        },
        formatPrice(val, curr) {
            return UiUtils.formatPrice(val, curr, this.getUserLanguage());
        },
        choseWatchlist() {
            // open modal
            const body = document.querySelector("body");
            this.watchlistSelectionModalActive = true;
            this.watchlistSelectionModalShow = true;
            body.classList.add("modal-open");            
        },
        async removeFromWatchlist() {
            this.$store.commit("setAppStateNotReady");
            const updateResponse = await ApiUtils.removeFromWatchlist(http, UiUtils, this.$store, this.getExchange.code, this.selectedItemCode);
            this.$store.commit("setAppStateReady");
            if (updateResponse) {
                // check answer
                if (updateResponse.error) {
                    if (ApiUtils.handleTraderNonRecoverableError(updateResponse, this.$store, this.$router, this.getUserLanguage)) {
                        return;
                    }
                    if (parseInt(updateResponse.type) != 0) {
                        // API error
                        // get the error message if appropriate
                        const errorCode = HttpUtils.getStatusMessage(updateResponse.type, this.getUserLanguage);
                        this.$toast.error(errorCode, {
                            "duration": 5000,
                            "pauseOnHover": true
                        });
                        this.$store.commit("addSystemMessage", {
                            date: (new Date()).getTime(),
                            mess: errorCode,
                            error: true
                        });
                    }
                } else {
                    this.$toast.success(this.getRemovedFromWatchlistMessage, {
                        "duration": 5000,
                        "pauseOnHover": true
                    });
                    this.$store.commit("addSystemMessage", {
                        date: (new Date()).getTime(),
                        mess: this.getRemovedFromWatchlistMessage,
                        error: false
                    });
                }
            }
        },        
        async updateWatchlist() {

            const exchanges = this.$store.getters["getExchanges"];
            const xCode = UiUtils.getExchangeCodeById(exchanges, this.selectedItemExchangeId);
            this.$store.commit("setAppStateNotReady");
            const updateResponse = await ApiUtils.updateDefaultWatchlist(http, UiUtils, this.$store, xCode, this.selectedItemCode);
            this.$store.commit("setAppStateReady");
            if (updateResponse) {
                // check answer
                if (updateResponse.error) {
                    if (ApiUtils.handleTraderNonRecoverableError(updateResponse, this.$store, this.$router, this.getUserLanguage)) {
                        return;
                    }
                    switch (parseInt(updateResponse.type)) {
                        case 1: {
                            // occupied name
                            this.$toast.error(this.getWatchlistNameOccupiedMessage, {
                                "duration": 5000,
                                "pauseOnHover": true
                            });
                            this.$store.commit("addSystemMessage", {
                                date: (new Date()).getTime(),
                                mess: this.getWatchlistNameOccupiedMessage,
                                error: true
                            });
                            break;
                        }
                        case 2: {
                            // watchlist contains element
                            this.$toast.error(this.getWatchlistContainsStockMessage, {
                                "duration": 5000,
                                "pauseOnHover": true
                            });
                            this.$store.commit("addSystemMessage", {
                                date: (new Date()).getTime(),
                                mess: this.getWatchlistContainsStockMessage,
                                error: true
                            });
                            break;
                        }
                        default: {
                            // API error
                            // get the error message if appropriate
                            const errorCode = HttpUtils.getStatusMessage(updateResponse.type, this.getUserLanguage);
                            this.$toast.error(errorCode, {
                                "duration": 5000,
                                "pauseOnHover": true
                            });
                            this.$store.commit("addSystemMessage", {
                                date: (new Date()).getTime(),
                                mess: errorCode,
                                error: true
                            });
                            break;
                        }
                    }
                } else {
                    this.$toast.success(this.getAddedToWatchlistMessage, {
                        "duration": 5000,
                        "pauseOnHover": true
                    });
                    this.$store.commit("addSystemMessage", {
                        date: (new Date()).getTime(),
                        mess: this.getAddedToWatchlistMessage,
                        error: false
                    });
                }
            }

            this.watchlistSelectionModalActive = false;
            this.watchlistSelectionModalShow = false;
        },
        async getQuoteTr() {
            if ("" === this.selectedItemCode) {
                return;
            }
            // get quote trading for selected item
            const user = this.$store.getters["getUser"];
            // get exchange code
            const exchanges = this.$store.getters["getExchanges"];
            const itemExchangeCode = UiUtils.getExchangeCodeById(exchanges, this.$store.getters["getSelectedTradingExchangeId"]);
            try {
                const res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: "get_quote_tr",
                        id: user.id,
                        key: user.key,
                        sc: UiUtils.combineExchangeStockPair(itemExchangeCode, this.selectedItemCode)
                    }
                });
                if (res) {
                    // check answer
                    if (ApiUtils.isApiResponseInvalidSession(res)) {
                        this.$store.commit("setAppStateReady");
                        // logout
                        setTimeout(
                            ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
                            500);
                        return;
                    }
                    // get the error message if appropriate
                    const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage());
                    if (errorCode === "") {
                        // set quote tr
                        this.quoteTrading = res.data;
                        this.$store.commit("setQuoteTrading", res.data);
                    } else {
                        this.$toast.error(errorCode, {
                            "duration": 5000,
                            "pauseOnHover": true
                        });
                        this.$store.commit("addSystemMessage", {
                            date: (new Date()).getTime(),
                            mess: errorCode,
                            error: true
                        });
                    }
                }
            } catch (err) {
                console.error(err);
            }
        },
        async setQuoteTr(code) {
            if ("" === code) {
                return;
            }
            // set sse for quote tr
            // get exchange code
            const exchanges = this.$store.getters["getExchanges"];
            const itemExchangeCode = UiUtils.getExchangeCodeById(exchanges, this.$store.getters["getSelectedTradingExchangeId"]);
            await ApiUtils.setQuoteTrading(http, UiUtils, this.$store, itemExchangeCode, code);
        },
        inExtendedInfoMenuItemClick(name) {
            this.activeExtendedStockItem = name.toString().toUpperCase();
        },
        formOrderObject(event) {
            this.orderModel.type = this.getOrderType(event.t);
            this.orderModel.ex = event.xc;
            this.orderModel.code = event.sc;
            this.orderModel.name = 0 === 'BG'.localeCompare(this.getUserLanguage())
                ? event.nBG
                : event.nEN;
            this.orderModel.amount = this.parseNumber(event.qty);
            this.orderModel.price = event.sp;
            this.orderModel.price_total = event.pt;
            this.orderModel.currency = event.cc;
            this.orderModel.stid = event.stid;
            this.orderModel.oid = event.id;
            this.orderModel.fee = event.fee;
            this.orderModel.time = this.getDate(event.d);
            this.orderModel.total_amount = Number(event.pt || 0) + Number(event.fee || 0);
        },
        getSelectedStockIndex() {
            if ("" === this.selectedItemCode) {
                return -1;
            }

            const indexedStocks = this.$store.getters["getIndexedStocks"];
            return indexedStocks.indexOf(this.selectedItemExchangeId + this.selectedItemCode);
        },
        async getXfraStockDetails(stockCode) {
            const user = this.$store.getters["getUser"];
            try {
                const res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: "get_stock_xfra",
                        id: user.id,
                        key: user.key,
                        sc: stockCode
                    }
                });
                if (!res) {
                    return null;
                }
                if (ApiUtils.isApiResponseInvalidSession(res)) {
                    this.$store.commit("setAppStateReady");
                    setTimeout(
                        ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
                        500);
                    return null;
                }

                return res.data?.stock || res.data?.d || res.data;
            } catch (e) {
                console.error(e);
            }

            return null;
        },
        async ensureXfraIsin() {
            const exchangeCode = this.getExchange?.code?.toString().toUpperCase();
            if (0 !== "XFRA".localeCompare(exchangeCode) || this.getStockIsin || !this.selectedItemCode) {
                return;
            }

            const requestKey = `${exchangeCode}${this.selectedItemCode}`;
            if (this.xfraIsinRequests[requestKey]) {
                return;
            }
            this.xfraIsinRequests[requestKey] = "loading";

            const details = await this.getXfraStockDetails(this.selectedItemCode);
            const isin = details?.isin || details?.ISIN || details?.isinCode || details?.is || details?.i;
            if (isin) {
                this.$store.commit("updateStock", {
                    cMIC: this.selectedItemExchangeId,
                    code: this.selectedItemCode,
                    isin
                });
            }
            this.xfraIsinRequests[requestKey] = "done";
        },        
        calculateNumberOfMeaningfulDigits(val) {
            return UiUtils.calculateNumberOfMeaningfulDigits(val);
        },
        async getXfraData(xfraList) {
            const validXfraList = (xfraList || []).filter(stockCode => Boolean(stockCode));
            if (0 === validXfraList.length) {
                return;
            }
            const user = this.$store.getters["getUser"];
            // get exchanges and stocks
            try {
                const res = await http.getApiClient(this.getUserType()).get("", {
                    params: {
                        a: "get_stocks_full_xfra",
                        id: user.id,
                        key: user.key,
                        sc: validXfraList.join()
                    }
                });
                if (res) {
                    // check answer
                    if (ApiUtils.isApiResponseInvalidSession(res)) {
                        this.$store.commit("setAppStateReady");
                        // logout
                        setTimeout(
                            ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.getInvalidSessionLabel, 1),
                            500);
                        return;
                    }
                    if (0 === res.data.ec) {
                        // add exchange index (hardcoded 3)
                        res.data.stocks.forEach(item => {
                            // this answer does not comply with the get_exchanges_stocks_ex answer
                            item.code = item.sc;
                            item.cMIC = 3;
                            item.tID = item.stid;
                            this.$store.commit("addStock", item);
                        })
                        await this.ensureXfraIsin();
                    }
                }
            } catch (e) {
                console.error(e);
            }
        }        
    },
    computed: {
        getWindowsWidth() {
            return this.$store.getters["getAppWindowWidth"] || window.innerWidth;
        },          
        chartSeriesData() {
            return this.seriesData?.[0]?.data || [];
        },
        hasChartData() {
            return 0 < this.chartSeriesData.length;
        },
        getStockName() {
            if (!this.selectedItemCode) {
                return STRING_NOT_AVAILABLE;
            }
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            // if we have no info in current stocks list and this is XFRA item
            // we should call the API for additional info
            const stockName = UiUtils.getStockName(stocks, indexedStocks, this.selectedItemCode, this.selectedItemExchangeId, this.getUserLanguage());

            if (0 !== STRING_NOT_AVAILABLE.localeCompare(stockName))
            {
                return stockName;
            }

            (async () => {
                // gathering data could be a long process, so we set the wait
                this.$store.commit("setAppStateNotReady");
                const xfraList = [];
                xfraList.push(this.selectedItemCode);
                await this.getXfraData(xfraList);
                await this.ensureXfraIsin();
                this.$store.commit("setAppStateReady");
            })();

            return UiUtils.getStockName(stocks, indexedStocks, this.selectedItemCode, this.selectedItemExchangeId, this.getUserLanguage());
        },
        getExchange() {
            try {
                const exchanges = this.$store.getters["getExchanges"];
                if (exchanges && 0 < exchanges?.length) {
                    // find exchange 
                    const exchange = exchanges.filter(item => {
                        return parseInt(item.eID) === parseInt(this.selectedItemExchangeId);
                    })[0];
                    return exchange;
                }
            } catch (error) {
                console.error(error);
            }
            return {};
        },
        isClosedMarked() {
            const quoteEx = this.$store.getters["getQuoteExtended"];
            const mp = quoteEx?.ph || '';
            return 0 === mp.toString().toUpperCase().localeCompare("ENDTR") 
                || 0 === mp.toString().toUpperCase().localeCompare("CLOSE");
        },
        getMarketPhaseLabel() {
            const quoteEx = this.$store.getters["getQuoteExtended"];
            const mp = quoteEx?.ph || '';
            return 0 === mp.toString().toUpperCase().localeCompare("ENDTR") 
                || 0 === mp.toString().toUpperCase().localeCompare("CLOSE")
                ? this.t("closedLabel") 
                : this.t("openedLabel");
        },        
        getInformationLabel() {
            return this.t("informationLabel");
        },
        getDepthLabel() {
            return this.t("depthLabel");
        },
        getGraphLabel() {
            return this.t("graphLabel");
        },
        getTradeLabel() {
            return this.t("tradeLabel");
        },
        getExchangeNameLabel() {
            return this.t("exchangeLabel");
        },
        getSegmentLabel() {
            return this.t("segmentLabel");
        },
        getInstrumentTypeLabel() {
            return this.t("instrumentTypeLabel");
        },
        getExchangePhaseLabel() {
            return this.t("exchangePhaseLabel");
        },
        getExchangePricesLabel() {
            return this.t("exchangePricesLabel");
        },
        getPreviousCloseLabel() {
            return this.t("previousCloseLabel");
        },
        getDailyVolumeLabel() {
            return this.t("dailyVolumeLabel");
        }, 
        getTotalAmountLabel() {
            return this.t("totalAmountLabel");
        },
        getQuantityLabel() {
            return this.t("quantityLabel");
        },
        getBidLabel() {
            return this.t("bidLabel");
        },
        getAskLabel() {
            return this.t("askLabel");
        },
        getOneYearReturnLabel() {
            return this.t("oneYearReturnLabel");
        },
        getMarketCapLabel() {
            return this.t("marketCapLabel");
        },
        getLastTransactionLabel() {
            return this.t("lastTransactionLabel");
        },
        getOrdersLabel() {
            return this.t("ordersLabel");
        },
        getCouldNotReadPhasesMessage() {
            return this.t("couldNotReadPhasesMessage");
        },
        getCouldNotReadHistoryMessage() {
            return this.t("couldNotReadHistoryMessage");
        },
        getCouldNotSetQuoteMessage() {
            return this.t("couldNotSetQuoteMessage");
        },
        getWatchlistSelectionLabel() {
            return this.t("watchlistSelectionLabel");
        },
        getCloseLabel() {
            return this.t("closeLabel");
        },
        getSaveLabel() {
            return this.t("saveLabel");
        },
        getNewWatchlistNameLabel() {
            return this.t("newWatchlistNameLabel");
        },
        getExistingWatchlistNameLabel() {
            return this.t("existingWatchlistNameLabel");
        },
        getWatchlistNameLabel() {
            return this.t("watchlistLabel");
        },
        getWatchlistNamePlaceholder() {
            return this.t("watchlistNamePlaceholder");
        },
        getCouldNotUpdateWatchlistMessage() {
            return this.t("couldNotUpdateWatchlistMessage");
        },
        getStockNotAddedMessage() {
            return this.t("stockNotAddedMessage");
        },
        getWatchlistNameOccupiedMessage() {
            return this.t("watchlistNameOccupiedMessage");
        },
        getWatchlists() {
            const user = this.$store.getters["getUser"];
            return user && Array.isArray(user.wls) ? user.wls : [];
        },
        getAddedToWatchlistMessage() {
            return this.t("addedToWatchlistMessage");
        },
        getSelectedTradingCode() {
            return this.$store.getters["getSelectedTradingCode"];
        },
        getCouldNotReadQuotesMessage() {
            return this.t("couldNotReadQuotesMessage");
        },
        getReestablishingConnectionLabel() {
            return this.t("reestablishingConnectionLabel");
        }, 
        getReestablishedConnectionLabel() {
            return this.t("reestablishedConnectionLabel");
        },
        getChartDataForInstrumentUnavailableMessage() {
            return this.t("chartDataForInstrumentUnavailableMessage");
        },
        getInvalidSessionLabel() {
            return this.t("invalidSessionLabel");
        },
        getTickSizeLabel() {
            return this.t("tickSizeLabel");
        },        
        isStockPartOfDefaultWatchlist() {
            if ("" === this.selectedItemCode) {
                return false;
            }
            const user = this.$store.getters["getUser"];
            if (!user || !Array.isArray(user.wls)) {
                return false;
            }
            const xCode = this.getExchange;
            let hasItem = false;
            for (let cnt = 0; cnt < user.wls.length; cnt++) {
                const wl = user.wls[cnt];
                if (0 == wl.wln.toString().toLowerCase().localeCompare("default")) {
                    hasItem = UiUtils.verifyPairListContainsElement(wl.sc, UiUtils.createExchangeStockCodePairObject(xCode.code, this.selectedItemCode));
                    if (hasItem) { break; }
                }
            }
            return hasItem;
        },
        getRemovedFromWatchlistMessage() {
            return this.t("removedFromWatchlistMessage");
        },
        getStockCurrency() {
            if (2 === this.$store.getters["getSelectedTradingCodeShareTypeId"]) {
                return "%";
            }
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];

            return UiUtils.getStockCurrency(stocks, indexedStocks, this.selectedItemCode, this.selectedItemExchangeId);
        },
        getStockTypeId() {
            if ("" === this.selectedItemCode) {
                return 1;
            }
            const indexedStocks = this.$store.getters["getIndexedStocks"];
            const stocks = this.$store.getters["getStocks"];
            const stockIndex = indexedStocks.indexOf(this.selectedItemExchangeId + this.selectedItemCode);

            return stocks[stockIndex]?.tID || 1;
        },
        getSelectedStock() {
            const stocks = this.$store.getters["getStocks"];
            const stockIndex = this.getSelectedStockIndex();

            return 0 <= stockIndex ? stocks[stockIndex] : null;
        },
        isStockInfoReady() {
            const exchangeCode = this.getExchange?.code?.toString().toUpperCase();
            if (0 !== "XFRA".localeCompare(exchangeCode) || this.getStockIsin || !this.selectedItemCode) {
                return true;
            }

            return "done" === this.xfraIsinRequests[`${exchangeCode}${this.selectedItemCode}`];
        },
        getStockIsin() {
            const stock = this.getSelectedStock;
            return stock?.isin || stock?.ISIN || stock?.isinCode || stock?.is || stock?.i || "";
        },
        getStockTypeLabel() {
            return getStockTypeLabel(this.getStockTypeId, {
                bonds: this.t("bondsLabel"),
                cfd: this.t("cfdLabel"),
                compInstruments: this.t("compInstrumentsLabel"),
                equities: this.t("equitiesLabel"),
                funds: this.t("fundsLabel"),
                margin: this.t("marginLabel"),
                netting: this.t("nettingLabel"),
                reits: this.t("reitsLabel"),
                repo: this.t("repoLabel"),
                rights: this.t("rightsLabel"),
                stocksAndEtfs: this.t("stocksAndEtfsLabel"),
                other: this.t("othersLabel"),
                unknown: this.t("othersLabel"),
            });
        },
        calculateTickSize() {
            // algo from trader
            const quoteTr = this.$store.getters["getQuoteTrading"];
            if (!quoteTr) {
                return 0.0;
            }

            let orderSharePrice = quoteTr.a;
            let liqBandNumber = quoteTr.lbn;

            if (0 >= orderSharePrice) {
                orderSharePrice = quoteTr.ltp;
            }
            if (0 >= orderSharePrice) {
                orderSharePrice = quoteTr.clp;
            }
            if (64 === liqBandNumber && 1 === orderSharePrice) return 0.001;
            switch (liqBandNumber) {
                case 82: return 0.001;
                case 83: return 0.0001;
                case 84: return 0.001;
                case 85: return 0.001;
                case 86: return 0.001;
            }

            switch (liqBandNumber) {
                case 33: liqBandNumber = 1; break;
                case 34: liqBandNumber = 2; break;
                case 35: liqBandNumber = 3; break;
                case 37: liqBandNumber = 4; break;
                case 38: liqBandNumber = 5; break;
                case 39: liqBandNumber = 6; break;
                case 40: liqBandNumber = 7; break;
                case 41: liqBandNumber = 8; break;
                case 42: liqBandNumber = 9; break;
                case 43: liqBandNumber = 10; break;
                case 90: liqBandNumber = 2; break;
                case 91: liqBandNumber = 1; break;
            }
            if (0 >= liqBandNumber || 10 < liqBandNumber) return 0;

            let tickSize = sdMaxTickSizes[liqBandNumber];

            for (let i = 18; i > 0; i--) {
                if (orderSharePrice >= sdLiqPriceLevels[i]) {
                    break;
                }
                if (tickSize >= 500) tickSize = 200;
                else if (tickSize >= 200) tickSize = 100;
                else if (tickSize >= 100) tickSize = 50;
                else if (tickSize >= 50) tickSize = 20;
                else if (tickSize >= 20) tickSize = 10;
                else if (tickSize >= 10) tickSize = 5;
                else if (tickSize >= 5) tickSize = 2;
                else if (tickSize >= 2) tickSize = 1;
                else if (tickSize >= 1) tickSize = 0.5;
                else if (tickSize >= 0.5) tickSize = 0.2;
                else if (tickSize >= 0.2) tickSize = 0.1;
                else if (tickSize >= 0.1) tickSize = 0.05;
                else if (tickSize >= 0.05) tickSize = 0.02;
                else if (tickSize >= 0.02) tickSize = 0.01;
                else if (tickSize >= 0.01) tickSize = 0.005;
                else if (tickSize >= 0.005) tickSize = 0.002;
                else if (tickSize >= 0.002) tickSize = 0.001;
                else if (tickSize >= 0.001) tickSize = 0.0005;
                else if (tickSize >= 0.0005) tickSize = 0.0002;
                else if (tickSize >= 0.0002) tickSize = 0.0001;
            }
            return tickSize;
        },
        stopSseState() {
        return this.$store.getters["getStopSse"];
        }
    },
    async mounted() {
        await Promise.all([this.getQuoteTr(), this.setQuoteExAndDepth(), this.getQuoteExAndDepth(), this.getInstrumentHistory()])
        await this.ensureXfraIsin();
        this.getQuoteEx();
        this.hasEvents = false;        
        // start sse monitor
        this.sseVerifier = startSseMonitor({
            getClient: () => this.sseClient,
            setClient: (client) => { this.sseClient = client; },
            hasEvents: () => this.hasEvents,
            setupStream: () => this.setupStream()
        });
    },
    beforeUnmount() {
        // clear the timeout before the component is destroyed
        clearTimeout(this.timeout);
    },
    unmounted() {
        // stop verifier
        stopSseMonitor(this.sseVerifier);
        // close sse
        closeSseClient(this.sseClient);
    }
}
</script>

<style scoped>




    .greenColor {
        color: #189e18;
    }

    .redColor {
        color: #ff0000;
    }

    .whiteColor {
        color: #ffffff;
    }

    .blackColor {
        color: #000000;
    }

    .align-text-right {
        text-align: right !important;
    }
    .align-text-center {
        text-align: center !important;
    }

    .instrument-title {
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
        margin-bottom: 0;
    }

    .instrument-code-title {
        font-size: 0.95rem;
    }

    .instrument-header {
        display: flex;
        flex-direction: column;
        line-height: 1.15;
        margin-bottom: 0.35rem;
    }

    .instrument-code-main {
        color: #000000;
        font-size: 1.35rem;
        line-height: 1.1;
    }

    .instrument-name-main {
        color: #000000;
        font-size: 1.05rem;
        line-height: 1.2;
    }

    .instrument-price-row {
        align-items: center;
        border-bottom: 1px solid #dee2e6;
        display: flex;
        justify-content: space-between;
        gap: 1rem;
        padding-bottom: 0.4rem;
    }

    .instrument-price-main {
        color: #000000;
        font-size: 1.25rem;
        line-height: 1.1;
    }

    .instrument-change-main {
        display: inline-block;
        font-size: 0.95rem;
        font-weight: 600;
        line-height: 1.2;
        margin-left: 0.25rem;
        vertical-align: super;
    }

    .instrument-change-negative {
        display: inline-block;
        font-size: 0.95rem;
        margin-left: 0.25rem;
        position: relative;
        top: 0.2em;
        vertical-align: baseline;
    }

    .instrument-details-table td {
        font-size: 1rem;
        line-height: 1.35;
        padding: 0.6rem 0.5rem;
    }

    .instrument-details-table td:first-child,
    .instrument-details-table td:first-child strong {
        font-weight: 400;
    }

    .instrument-details-table td:last-child {
        font-weight: 700;
    }

    .depth-order-book-table th,
    .depth-order-book-table td {
        font-size: 1rem;
        line-height: 1.35;
        padding: 0.6rem 0.5rem;
    }

    .instrument-info-row td {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        vertical-align: middle;
        white-space: nowrap;
    }

    .market-phase-cell {
        align-items: center;
        display: flex;
        font-size: 1rem;
        gap: 0.25rem;
        line-height: 1.35;
    }

    .market-phase-cell .label {
        font-size: inherit;
        line-height: inherit;
        margin: 0;
    }

    .trade-confirmed-modal-header {
        border-bottom: 0;
        justify-content: flex-end;
        padding-bottom: 0;
    }

    #history_depth_menu {
        width: 100%;
    }

    .chart-range-menu {
        display: flex;
        flex-wrap: nowrap;
        margin-top: 0.45rem;
        max-width: 100%;
        overflow-x: auto;
    }

    .chart-loading-state,
    .chart-empty-state {
        align-items: center;
        display: flex;
        justify-content: center;
        min-height: 240px;
        text-align: center;
    }

    .chart-empty-state h4 {
        font-size: 1rem;
        font-weight: 400;
        margin: 0;
    }

    #history_depth_menu .btn-check {
        max-width: 4.5rem;
    }

    #history_depth_menu .btn-outline-primary {
        max-width: 4.5rem;
        margin-right: 0.2rem;
    }

    .show_list_horizontal {
        overflow-x: auto; 
        max-width: 100%; 
        max-height: auto; 
        flex: 1; 
        flex-wrap: nowrap;
    }
</style>
